module.exports = __webpack_public_path__ + "img/fontsForEngravings@2x.929725d.webp";